import { Component, OnInit } from '@angular/core';
import { SEOService } from 'src/app/shared/seo.service';

@Component({
  selector: 'app-forums-topic',
  templateUrl: './forums-topic.component.html'
})
export class ForumsTopicComponent implements OnInit {
  aktif = 's1';
  bolumler = [
    { id: 's1', baslik: '1 · Kabul' },
    { id: 's2', baslik: '2 · Hizmet açıklaması' },
    { id: 's3', baslik: '3 · Kullanıcı hesapları' },
    { id: 's4', baslik: '4 · Kullanıcı sorumlulukları' },
    { id: 's5', baslik: '5 · Fikri mülkiyet' },
    { id: 's6', baslik: '6 · Gizlilik' },
    { id: 's7', baslik: '7 · Ücretler' },
    { id: 's8', baslik: '8 · Üçüncü taraf bağlantıları' },
    { id: 's9', baslik: '9 · Sorumluluk sınırları' }
  ];

  constructor(private seoService: SEOService) {}

  ngOnInit(): void {
    this.setMeta();
  }

  git(event: Event, id: string) {
    event.preventDefault();
    this.aktif = id;
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  setMeta() {
    const title = 'pratiu - Kullanıcı Şartları';
    this.seoService.updateDescription(title);
    this.seoService.updateKeywords('Pratiu şartları, kullanıcı şartları, kullanıcı sözleşmesi');
    this.seoService.updateTitle(title);
  }
}
